import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Game } from './pages/Game/Game';
import { ThemeProvider } from 'styled-components';
import { theme } from './constants/theme';
import { GameProvider } from './context/GameContext';
import { PlayerProvider } from './context/PlayerContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <GameProvider>
        <PlayerProvider>
          <Game />
        </PlayerProvider>
      </GameProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
